<template>
  <div :id="courseMasterID" :class="['panel panel-default gcc-course', {'is-selected': courseSelected}]">

    <div class="panel-heading" role="tab" :id="`${courseMasterID}-heading`">
      <div class="panel-title text-left" :aria-labelledby="course.CourseTitle">

        <!-- Check Mark -->
        <button class="btn btn-transparent btn-width col-xs-2 col-sm-2 col-md-2 col-lg-2"
          @click.stop="toggleCourseSelection">
          <i class="fas fa-check"></i>
        </button>
        <!-- Check Mark -->

        <!-- Course Title + Collapse -->
        <a class="col-xs-8 col-sm-8 col-md-8 col-lg-8" role="button" data-toggle="collapse" data-parent="#gcc-course-list" :href="`#${courseMasterID}-collapse`" aria-expanded="false" :aria-controls="`${courseMasterID}-collapse`">{{ course.CourseTitle | excerpt(28) }}</a>
        <!-- Course Title + Collapse -->

        <!-- Collapse Icon -->
        <a class="pull-right text-align-right col-xs-2 col-sm-2 col-md-2 col-lg-2" role="button" data-toggle="collapse" data-parent="#gcc-course-list" :href="`#${courseMasterID}-collapse`" aria-expanded="false" :aria-controls="`${courseMasterID}-collapse`" style="display: inline-block;">
          <i class="fas fa-caret-right" v-if="course.CohortProgressDataList.length > 0"></i>
        </a>
        <!-- Collapse Icon -->

      </div>

      <!-- Cohort + Participant Counts -->
      <div class="course-counts text-left">
        <i>{{ `${cohortCount} Cohorts - ${enrolmentCount} Enrolments` }}</i>
      </div>
      <!-- Cohort + Participant Counts -->

    </div>

    <!-- Cohorts List -->
    <div :id="`${course.GroupCourseMasterId}-collapse`" class="panel-collapse collapse in" role="tabpanel" :aria-labelledby="`${course.GroupCourseMasterId}-heading`">
      <div class="panel-body">
        <ul class="list-group gcc-cohort-list">

          <li class="list-group-item selection-controls-item" v-if="courseCohorts.length > 0">
            <div class="text-left">
              <div class="btn-group cohort-selection-controls" role="group" aria-label="Selection Controls">
                <button type="button" class="btn btn-default btn-xs deselect-all-cohorts"
                  :id="`deselect-all-cohorts-${courseMasterID}`"
                  :disabled="!hasSelectedCohorts"
                  @click.stop="deselectAllCohorts">
                    Clear All
                </button>

                <button type="button" class="btn btn-default btn-xs select-all-cohorts"
                  :id="`select-all-cohorts-${courseMasterID}`"
                  :disabled="hasAllCohortsSelected"
                  @click.stop="selectAllCohorts">
                    Select All
                  </button>
              </div>
            </div>
          </li>

          <gcc-cohort v-for="cohort in cohorts" :key="cohort.CohortId" :cohortObj="cohort" :isSelected="cohort.isSelected"></gcc-cohort>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import GCCFilterCohort from '@/components/dashboard_v2/GCCFilterCohort'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import filter from 'lodash/filter'
import sumBy from 'lodash/sumBy'
export default {
  name: 'GccCourse',

  components: {
    'gcc-cohort': GCCFilterCohort
  },

  props: {
    courseObj: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      course: this.courseObj,
      courseSelected: false,
      cohorts: {},

      /* eslint-disable */
      selectAllCohortsButton: this.selectAllButton,
      deselectAllCohortsButton: this.deselectAllButton
      /* eslint-enable */
    }
  },

  computed: {
    courseCohorts () {
      return this.course.CohortProgressDataList
    },

    courseMasterID () {
      return this.course.GroupCourseMasterId
    },

    cohortCount () {
      return this.cohorts.length
    },

    selectedCohortCount () {
      return filter(this.selectedCourseCohorts, (obj) => {
        return obj.isSelected === true
      }).length
    },

    unSelectedCohortCount () {
      return filter(this.selectedCourseCohorts, (obj) => {
        return obj.isSelected === false
      }).length
    },

    enrolmentCount () {
      let enrolmentCount = 0

      switch (this.currDashboardTabSelection) {
        default:
        case 1:
          /* eslint-disable */
          _.forEach(this.cohorts, cohort => {
            enrolmentCount += _.filter(cohort.DashboardDataList, stat => {
              return !stat.isUnEnrolled
            }).length
          })
          /* eslint-enable */
          break
        case 2:
          enrolmentCount = sumBy(this.cohorts, cohort => {
            return cohort.TotalUsers
          })
          break
      }
      return enrolmentCount
    },

    selectAllButton () {
      // eslint-disable-next-line
      return $(`#select-all-cohorts-${this.courseMasterID}`)
    },

    deselectAllButton () {
      // eslint-disable-next-line
      return $(`#deselect-all-cohorts-${this.courseMasterID}`)
    },

    selectedCourseCohorts () {
      // eslint-disable-next-line
      return _.filter(this.selectedCohorts, cohort => {
        return cohort.GroupCourseMasterId === this.courseMasterID
      })
    },

    hasSelectedCohorts () {
      return this.selectedCohortCount > 0
    },

    hasAllCohortsSelected () {
      return this.cohortCount === this.selectedCohortCount
    },

    selectedCohorts: {
      get: function () {
        return this.$store.getters.selectedCohorts
      }
    },

    selectedCourses: {
      get: function () {
        return this.$store.getters.selectedGroupCoursesWithNoFilter
      }
    },

    currDashboardTabSelection: {
      get: function () {
        return this.$store.getters.currDashboardTabSelection
      }
    }
  },

  created () {
    this.cohorts = this.courseCohorts
  },

  beforeDestroy () {
    this.eventHub.$off('deselectAllCourses')
    this.eventHub.$off('selectAllCourses')
    this.eventHub.$off('gccFilterUpdated')
  },

  mounted () {
    this.initCollapseIcons()
    this.eventHub.$on('gccFilterUpdated', () => {
      this.updateValuesInternally()
    })

    this.eventHub.$on('deselectAllCourses', () => {
      this.setCourseSelection(false)
    })

    this.eventHub.$on('selectAllCourses', () => {
      this.setCourseSelection(true)
    })

    this.selectAllCohortsButton = this.selectAllButton
    this.deselectAllCohortsButton = this.deselectAllButton
  },

  methods: {
    updateValuesInternally: function () {
      /*
        AK: Check and Update the isSelected flag on every gccFilterUpdated.
        Case: If user manually select or deselect the cohorts then to update the current course isSelected flag.
      */
      let selectedCourses = this.selectedCourses
      const updatedCourseObj = find(selectedCourses, (obj) => {
        return obj.GroupCourseMasterId === this.courseObj.GroupCourseMasterId
      })
      if (!isEmpty(updatedCourseObj)) {
        this.course = updatedCourseObj
        this.courseSelected = this.course.isSelected
      }
    },

    toggleCourseSelection () {
      this.courseSelected = !this.courseSelected

      /* eslint-disable */
      _.forEach(this.cohorts, cohort => {
        _.set(cohort, 'isSelected', this.courseSelected)
      })
      /* eslint-enable */
      this.eventHub.$emit('course-selection-toggled', this.courseMasterID, this.courseSelected)
    },

    setCourseSelection (isSelected) {
      this.courseSelected = isSelected

      /* eslint-disable */
      _.forEach(this.cohorts, cohort => {
        _.set(cohort, 'isSelected', isSelected)
      })
      /* eslint-enable */

      this.eventHub.$emit('course-selection-toggled', this.courseMasterID, isSelected)
    },

    selectAllCohorts () {
      this.selectAllCohortsButton.prop('disabled', true)
      this.deselectAllCohortsButton.prop('disabled', false)

      this.setCourseSelection(true)
    },

    deselectAllCohorts () {
      this.selectAllCohortsButton.prop('disabled', false)
      this.deselectAllCohortsButton.prop('disabled', true)

      this.setCourseSelection(false)
    },

    initCollapseIcons () {
      this.$nextTick(() => {
        /* eslint-disable */
        $('[data-toggle="tooltip"]').tooltip()

        $('.collapse')
          .on('show.bs.collapse', function () {
            $(this).parent().find('.fa-caret-right')
              .removeClass('fa-caret-right')
              .addClass('fa-caret-down')
          })
          .on('hide.bs.collapse', function () {
            $(this).parent().find('.fa-caret-down')
              .removeClass('fa-caret-down')
              .addClass('fa-caret-right')
          })
        /* eslint-enable */
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.course-selection-controls {
  margin-bottom: 1em;
  margin-top: 0.3em;

  .btn {
    background-color: #646464;
    color: white;
    border-color: #C8C8C8;
    outline: none;
    font-size: 12px;
    padding: 0.2em 1em;
  }

  .btn:hover,
  .btn:active {
    background-color: #505050;
    color: white;
    outline: none;
  }
}

.group-selector {
  margin: 0 auto 1em auto;
}

.red {
  color: #E56A6A;
  font-weight: bold;
}

.gcc-course {
  margin-bottom: 1em;

  .course-counts {
    display: inline-block;
    width: 100%;
    padding-left: 2.1em;
    font-weight: bold;
    font-size: 12px;
    text-transform: italic;
  }

  .panel-heading {
    font-family: 'Source Sans Pro', 'Avenir', 'Helvetica', sans-serif;
    padding-left: 10px;
    padding-right: 10px;
    border-bottom: none;

    h4 a {
      color: #27345B !important;
      font-size: 14px !important;
      font-weight: 400;
      margin-bottom: 0;
      display: inline-block !important;
      width: 100%;
      height: 100%;
      line-height: 1em;
      padding: 0 0 0 1.5em;

      svg.svg-inline--fa.fa-caret-right,
      svg.svg-inline--fa.fa-caret-down {
        margin: 0 5px;
        font-size: 18px;
      }
    }

    a:hover,
    a:focus,
    a:active {
      text-decoration: none;
    }
  }

  .gcc-cohort-list {
    margin-bottom: 0;
  }
}

.gcc-course .panel-heading svg.svg-inline--fa.fa-check {
  color: #C8C8C8;
  transition: all 100ms ease-in-out;
  margin-right: 0.5em;
}

.gcc-course.is-selected .panel-heading svg.svg-inline--fa.fa-check {
  color: #00BF00 !important;
}

.btn-transparent,
.btn-transparent:hover,
.btn-transparent:focus,
.btn-transparent:active {
  background-color: transparent;
  padding: 0;
  margin: 0;
  text-align: left;
  width: 90%;
  outline: none !important;
  box-shadow: none;
  font-weight: bold;
}

.gcc-course .panel-body {
  padding: 0;

  .list-group-item {
    border-radius: 0 !important;
    padding-left: 2.5em;
  }
}

.gcc-course .cohort-selection-controls {
  .btn {
    background-color: #646464;
    color: white;
    border-color: #C8C8C8;
    outline: none;
    font-size: 12px;
    padding: 0.2em 1em;
  }

  .btn:hover,
  .btn:active {
    background-color: #505050;
    color: white;
    outline: none;
  }
}

.btn-width {
  width: 10% !important;
}
.text-left {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard_v2/GCCFilterCourse.vue